/**
* Indexing critical/sync scripts
* * * * * * * * * * * *
*/
var init = {};
window.aSync = {};
window.acceptYoutubeCookies = false;

import '../styles/index.less';
import './plugins/formidable.js';

import { $ } from './plugins/globalJquery.js';
$ = ($ == undefined ? jQuery : $);

import * as defaultResets from './plugins/defaultResets.js';
import { waitFor } from './plugins/helpers.js';

import './plugins/icons.js';
import { breakpoints } from './modules/breakpoints.js';
import { Lazy } from 'eagerly-lazy-loader';
import { accordion } from './modules/accordion.js';
import { embed } from './modules/embed';
window.embed = embed;


/**
* Init critical/sync scripts
* * * * * * * * * * * *
*/
init.sync = function() {
	defaultResets.init();
	breakpoints.init();
	init.icons();
	window.lazy = new Lazy.init({
		log: 'none',
		panels: true
	});
	accordion.init();
	embed.init();
}


/**
* Update breakpoints resize
* * * * * * * * * * * *
*/
breakpoints.switch.device = function(size) {
	// console.log(breakpoints.this);
	$('body').icons.init('.svg-icon');
	// Update aSync functions
	if (typeof aSync.demo != 'undefined') {
		aSync.demo.resize();
	}
	if (typeof aSync.tips != 'undefined') {
		aSync.tips.resize();
	}
	if (matchMedia('(pointer:fine)').matches && $('#background .el-video.is-hero').length != '') {
		if (Modernizr.mq('(min-width: 1024px)')) {
			aSync.initYoutubeHero();
		} else if (typeof aSync.youtube != 'undefined') {
			aSync.youtube.backToPlaceholder($('#background .el-video.is-hero'));
		}
	}
};

breakpoints.resized = function() {
	window.lazy.resizeAll();
	accordion.resize();
	// Update aSync functions
	if (typeof aSync.navigation != 'undefined') {
		aSync.navigation.resize();
	}
	if (typeof aSync.search != 'undefined') {
		aSync.search.resize();
	}
	if (typeof aSync.scroll != 'undefined') {
		aSync.scroll.resize();
	}
	if (typeof aSync.youtube != 'undefined' && matchMedia('(pointer:fine)').matches && $('#background .el-video.is-hero').length != '') {
		if (Modernizr.mq('(min-width: 1024px)')) {
			aSync.youtube.scale($('#background .el-video.is-hero'));
		} else {
			$('#background .el-video.is-hero').removeAttr('style');
			window.lazy.resize(document.querySelector('#background .el-video.is-hero .lazy-align'));
		}
	}
};

breakpoints.switch.orientation = function() {
	// console.log('Orientation switch');
};



/**
* Init icons
* * * * * * * * * * * *
*/
init.icons = function() {
	$('body').icons({
		svg : customData.themePath + '/img/output/sprite.svg',
		offset : 2,
		ajax : true,
		testFallback : false,
		ready: function(prop) {
			// console.log(prop);
		}
	});
	$('body').icons.init('.svg-icon');
}



/**
* Indexing & init non-critical/aSync scripts
* * * * * * * * * * * *
*/
init.aSync = function() {
	initTips();
	initAgenda();
	initScroll();
	initNavigation();
	aSync.initSidebarForm();
	initSidebarTickets();
	aSync.initTicketsPopUp();
	aSync.initYoutube();
	aSync.initYoutubeHero();
	initLightbox();
	initFormidable();
}

function initTips() {
	if ($('.block-tips').length != '' && Modernizr.mq('(max-width: 767px)') && typeof aSync.tips == 'undefined') {
		import(
			/* webpackChunkName: "tips" */
			'./modules/tips.js'
		).then(module => {
			aSync.tips = module.tips;
			aSync.tips.init();
		}).catch(error => 'An error occurred while loading the component');
	}
}

function initAgenda() {
	if (typeof aSync.agenda == 'undefined' && $('#agenda').length != '') {
		import(
			/* webpackChunkName: "agenda" */
			'./modules/agenda.js'
		).then(module => {
			aSync.agenda = module.agenda;
			aSync.agenda.init();
		}).catch(error => 'An error occurred while loading the component');
	}
}

function initScroll() {
	if (typeof aSync.scroll == 'undefined') {
		import(
			/* webpackChunkName: "scroll" */
			'./modules/scroll.js'
		).then(module => {
			aSync.scroll = module.scroll;
			aSync.scroll.init();
		}).catch(error => 'An error occurred while loading the component');
	}
}

function initNavigation() {
	if (typeof aSync.navigation == 'undefined') {
		import(
			/* webpackChunkName: "sitewide" */
			'./modules/navigation.js'
		).then(module => {
			aSync.navigation = module.nav;
			aSync.navigation.init();
		}).catch(error => 'An error occurred while loading the component');
	}
	if (typeof aSync.search == 'undefined') {
		import(
			/* webpackChunkName: "sitewide" */
			'./modules/search.js'
		).then(module => {
			aSync.search = module.search;
			aSync.search.init();
		}).catch(error => 'An error occurred while loading the component');
	}
}

aSync.initSidebarForm = function() {
	if ( $('.block-sidebar-form').length > 0 ) {
		 if ( typeof aSync.sidebarForm == 'undefined') {
			import(
				/* webpackChunkName: "sidebarForm" */
				'./modules/sidebar-form.js'
			).then(module => {
				aSync.sidebarForm = module.form;
				aSync.sidebarForm.init();
			}).catch(error => 'An error occurred while loading the component');
		} else {
			aSync.sidebarForm.init();
		}
	}
}

function initSidebarTickets() {
	if ( $('#block-sidebar-tickets').length > 0 ) {
		if (typeof aSync.sidebarTickets == 'undefined') {
			import(
				/* webpackChunkName: "tickets-sidebar" */
				'./modules/sidebar-tickets.js'
			).then(module => {
				aSync.sidebarTickets = module.form;
				aSync.sidebarTickets.init();
			}).catch(error => 'An error occurred while loading the component');
		}
	}
}

aSync.initTicketsPopUp = function() {
	$('.js-tickets-pop-up').click(function(e) {
		e.preventDefault();
		let id = $(this).data('id'),
				redirect = $(this).data('redirect'),
				show_form = $(this).data('show_form');
		$('#ticket-pop-up-overlay').removeAttr('style').addClass('is-loading');
		if (typeof aSync.ticketsPopUp == 'undefined') {
			import(
				/* webpackChunkName: "tickets-pop-up" */
				'./modules/ticketsPopUp.js'
			).then(module => {
				aSync.ticketsPopUp = module.popup;
				aSync.ticketsPopUp.init(id, redirect, show_form);
			}).catch(error => 'An error occurred while loading the component');
		} else {
			aSync.ticketsPopUp.init(id, redirect, show_form);
		}
	});
}

aSync.initYoutube = function() {
	$('.youtube-video .play-button').unbind('click').click(function(e) {
		e.preventDefault();
		var $this = $(this).parents('.youtube-video');
		if (!$this.hasClass('loading') && !$this.hasClass('active')) {
			$this.addClass('loading');
			if (typeof aSync.youtube == 'undefined') {
				import(
					/* webpackChunkName: "youtube" */
					'./modules/youtube.js'
				).then(module => {
					aSync.youtube = module.youtube;
					aSync.youtube.play($this);
				}).catch(error => 'An error occurred while loading the component');
			} else {
				aSync.youtube.play($this);
			}
		}
	});
}

aSync.initYoutubeHero = function () {
	if (matchMedia('(pointer:fine)').matches && Modernizr.mq('(min-width: 1024px)') && window.acceptYoutubeCookies == true) {
		if ($('#background .el-video.is-hero').length != '') {
			var $this = $('#background .el-video.is-hero .youtube-video');
			if (!$this.hasClass('loading') && !$this.hasClass('active')) {
				$this.addClass('loading');
				if (typeof aSync.youtube == 'undefined') {
					import(
						/* webpackChunkName: "youtube" */
						'./modules/youtube.js'
					).then(module => {
						aSync.youtube = module.youtube;
						aSync.youtube.scale($('#background .el-video.is-hero'));
						aSync.youtube.play($this);
					}).catch(error => 'An error occurred while loading the component');
				} else {
					aSync.youtube.play($this);
				}
			}
		}
	}
}

function initLightbox() {
	if (typeof aSync.lightbox == 'undefined') {
		import(
			/* webpackChunkName: "lightbox" */
			'./modules/lightbox.js'
		).then(module => {
			aSync.lightbox = module.lightbox;
			aSync.lightbox.init();
		}).catch(error => 'An error occurred while loading the component');
	}
}

function initFormidable() {
	if ($('.frm_forms').length != '') {
		import(
			/* webpackChunkName: "formidable" */
			'./modules/formidable.js'
		).then(module => {
			aSync.formidable = module.form;
			aSync.formidable.init();
		}).catch(error => 'An error occurred while loading the component');
	}
}

document.addEventListener('DOMContentLoaded', function() {
    // Find all elements with the 'clickable-group' class
    var clickableGroups = document.querySelectorAll('.clickable-group');

    // Add a click event listener to each group
    clickableGroups.forEach(function(group) {
        group.addEventListener('click', function(event) {
            // Prevent the event from propagating to parent elements
            event.stopPropagation();

            // Redirect to the URL specified in the 'data-href' attribute
            window.location.href = group.getAttribute('data-url');
        });
    });
});

/**
* Init Project
* * * * * * * * * * * *
*/
$(() => {
	init.sync();
	init.aSync();
});

